import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    /**
     * Controlla che la stringa sia un CAP italiano valido (esattamente 5 cifre).
     */
    cap(errorMessage?: string): StringSchema;
  }
}

// CAP italiano: esattamente 5 cifre.
const capRegex = /^\d{5}$/;

yup.addMethod(
  yup.string,
  'cap',
  function (this: yup.StringSchema, errorMessage?: string) {
    return this.test(
      'cap',
      errorMessage ?? 'Il CAP deve essere di 5 cifre',
      value => {
        // I campi opzionali vuoti restano validi: l'obbligatorietà è gestita a parte.
        if (!value) return true;
        return capRegex.test(value);
      },
    );
  },
);
